module.exports = __webpack_public_path__ + "img/img_7.6c2bfeeb.jpg";